"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSelectedStroke = exports.StyledSelectedBorder = exports.StyledBorderInput = exports.StyledBorderSliderTitle = exports.StyledBorderSliderContainer = exports.StyledBorderStrokeOptions = exports.StyledBorderStrokeContainer = exports.StyledBorderBehavior = exports.StyledBorderDivider = exports.StyledBorderDividerContainer = exports.StyledBorderOptionsType = exports.StyledBorderContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem, toRemString } = ui_common_components_1.utils;
exports.StyledBorderContainer = styled_components_1.default.div `
  display: inline-flex;
  align-items: center;
  height: 100%;
  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${rem(theme.Spacing.Size.Small)};
    gap: ${rem(theme.Spacing.Size.XSmall)};
  `}
`;
exports.StyledBorderOptionsType = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  ${({ theme }) => (0, styled_components_1.css) `
    grid-gap: ${rem(theme.Spacing.Size.XXSmall)};
  `}
`;
exports.StyledBorderDividerContainer = styled_components_1.default.div `
  display: flex;
`;
exports.StyledBorderDivider = styled_components_1.default.hr `
  width: ${({ theme }) => rem(theme.Border.Size.Small)};
  min-height: ${rem(128)};
  height: 100%;
`;
exports.StyledBorderBehavior = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  height: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledBorderStrokeContainer = styled_components_1.default.div `
  padding: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => rem(theme.Spacing.Size.MediumLarge)};
`;
exports.StyledBorderStrokeOptions = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
`;
exports.StyledBorderSliderContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  flex-direction: column;
`;
exports.StyledBorderSliderTitle = styled_components_1.default.div `
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;
const inputWidth = 90;
exports.StyledBorderInput = styled_components_1.default.span `
  display: flex;
  max-width: ${rem(inputWidth)};
  max-height: ${({ theme }) => rem(theme.Spacing.Size.MediumLarge)};
`;
exports.StyledSelectedBorder = styled_components_1.default.div `
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  background-color: ${({ active, theme }) => active ? theme.Color.Neutrals.Light : 'transparent'};
`;
exports.StyledSelectedStroke = styled_components_1.default.div `
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};

  ${({ active, theme }) => (0, styled_components_1.css) `
    box-shadow: ${toRemString([0, 0, 0, 1])}
      ${active ? theme.Color.System.Primary : theme.Color.Neutrals.Border};
    transition: ${theme.Transition.Timing.Out};
  `}

  & > button {
    &:hover {
      background-color: transparent;
    }
  }
`;
//# sourceMappingURL=Border.styles.js.map